import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  info: null,
};

export const patientInfoSlice = createSlice({
  name: "patient-info-slice",
  initialState,
  reducers: {
    setPatientInfo: (state, action) => {
      state.info = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setPatientInfo } = patientInfoSlice.actions;

export default patientInfoSlice.reducer;
